import type { EmvKernelProfileDto } from "../../types/EmvKernelProfileDto";
import type { EmvKernelProfileEntity } from "../../types/EmvKernelProfileEntity";

export const EmvKernelProfileDtoToEntity = ({ ...rest }: Readonly<EmvKernelProfileDto>): EmvKernelProfileEntity => {
    return { ...rest };
};
